<template>
    <div class="p-6 bg-0A1129 text-white min-h-screen">
        <Mainlayout></Mainlayout>
        <div style="width:85%;margin:0 auto">
            <div class="flex flex-wrap md:flex-nowrap gap-8">
                <br /> <br /> <br /> <br />
                <!-- Left Content -->
                <div class="w-full md:w-1/2 space-y-4 text-center">
    
                    <h1 class="text-2xl font-semibold">Senarai pakej yang anda pilih</h1>
                    <div class="p-4">
                        <CRow>
                            <CCol sm="3">
                                <div>
                                    <div class="fw-bold fs-5">Member</div>
                                    <div>{{ product.NoOfStudent }} student</div>
                                </div>
                            </CCol>
                            <CCol sm="3">
                                <div>
                                    <div class="fw-bold fs-5">Level</div>
                                    <div>All Level</div>
                                </div>
                            </CCol>
                            <CCol sm="3">
                                <div class="align-items-center">
                                    <div class="fw-bold fs-5">Certificate</div>
                                    <img src="../assets/img/flyhigh/tick-circle.png" width="20px" />
                                </div>
                            </CCol>
                            <CCol sm="3">
                                <div class="align-items-center">
                                    <div class="fw-bold fs-5">Private Consultation</div>
                                    <img src="../assets/img/flyhigh/tick-circle.png" width="20px" />
                                </div>
                            </CCol>
                        </CRow>
                        <CRow class="mt-5">
                            <CCol sm="6">
                                <img :src="product.PicturePath" style="max-width:100%" alt="Fly High Program" class="rounded shadow-md w-full" />
    
                                <div>
                                    <h2 class="text-lg font-semibold mt-4 text-left">Description</h2>
                                    <p class="mb-2 font-semibold text-left" v-html="product.Description"></p>
    
                                </div>
    
                                <div class="mt-4">
                                    <CRow>
                                        <CCol sm="6">
                                            <div class="font-semibold text-left">Date/Time</div>
                                            <div class="text-sm text-left">{{ product.DateCourse | moment("DD/MM/YYYY")}} - {{ product.TimeCourse | moment( "HH:mm" ) }}</div>
                                        </CCol>
                                        <CCol sm="6">
                                            <div class="font-semibold text-left">Price</div>
                                            <div class="text-sm text-left">RM {{ product.Price - product.Discount }} / Class</div>
                                        </CCol>
                                    </CRow>
    
    
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="w-full md:w-1/2 bg-01173E p-4 rounded-lg shadow-md">
                                    <div class="text-lg font-semibold mb-2 custom-24px-600 text-left">Subject Information</div>
                                  
                                    <select v-model="selectedCourseName" class="w-full p-2 mb-4 bg-gray-800 text-white rounded">
                                        <option value="">All Subjects</option>
                                        <option
                                          v-for="course in distinctCourseNames"
                                          :key="course.CourseName"
                                          :value="course.CourseName"
                                        >
                                          {{ course.CourseName }}
                                        </option>
                                      </select>
                                      <div style="max-height: 400px; overflow-y: auto;">
                                        <table class="w-full custom-table text-sm text-left rounded">
                                          <thead class="sticky top-0 z-10">
                                            <tr class="text-gray-400 border-b border-gray-700">
                                              <th class="py-2 px-3">Select</th>
                                              <th class="py-2 px-3">Subject</th>
                                              <th class="py-2 px-3">Date</th>
                                              <th class="py-2 px-3">Price</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr
                                              v-for="(course, index) in filteredCourseSessions"
                                              :key="index"
                                              class="border-b border-gray-700"
                                            >
                                            <td class="py-2 px-3" :class="{ 'ml-4': index > 0 }">
                                                <input
                                                  type="checkbox"
                                                  :value="course"
                                                  v-model="selectedSubjects"
                                                  :disabled="isCourseDisabled(course)"
                                                  @change="handleCheckboxChange(course)"
                                                  :class="{ 'ml-4': index > 0 }"
                                                />
                                            </td>   
                                              <td class="py-2 px-3">{{ course.CourseName }}</td>
                                              <td class="py-2 px-3">{{ course.Date | moment("DD/MM/YYYY") }}</td>
                                              <td class="py-2 px-3">RM  {{ (course.Price != null && course.Discount != null) ? (course.Price - course.Discount) : '' }}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <div class="mt-4 font-semibold text-white text-left">
                                        Total Price: 
                                        <strong class="font-color-1796FD">
                                            RM {{
  isFullPackageSelected
    ? (product.Price - (product.Discount || 0))
    : selectedSubjects.reduce((sum, s) => sum + (s.Price - (s.Discount || 0)), 0)
}}
                                        </strong>
                                        </div>
    
                                    <button class="w-full mt-4 bg-blue-500 hover:bg-blue-600 text-white py-2 rounded bg-1796FD" @click="AddToCartAndGoToCart">
                                        Add to cart
                                      </button>
                                </div>

                                <div class="w-full md:w-1/2 bg-01173E p-4 rounded-lg shadow-md mt-3">
                                    <div class="text-lg font-semibold mb-2 custom-24px-600 text-left">Schedule Information</div>
                                  
                                      <!-- <select v-model="selectedCourseName" class="w-full p-2 mb-4 bg-gray-800 text-white rounded">
                                          <option disabled value="">Selected Subject</option>
                                          <option
                                            v-for="course in distinctCourseNames"
                                            :key="course.CourseName"
                                            :value="course.CourseName"
                                          >
                                            {{ course.CourseName }}
                                          </option>
                                      </select> -->
    
                                      <div style="max-height: 400px; overflow-y: auto;">
                                        <table class="w-full custom-table text-sm text-left rounded">
                                          <thead class="sticky top-0 z-10">
                                            <tr class="text-gray-400 border-b border-gray-700">
                                              <th class="py-2 px-3">Subject</th>
                                              <th class="py-2 px-3">Date</th>
                                              <th class="py-2 px-3">Time</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr
                                              v-for="(course, index) in filteredCourseSessions.slice(1)"
                                              :key="index"
                                              class="border-b border-gray-700"
                                            >
                                          
                                              <td class="py-2 px-3">{{ course.CourseName }}</td>
                                              <td class="py-2 px-3">{{ course.Date | moment("DD/MM/YYYY") }}</td>
                                              <td class="py-2 px-3">{{ course.Time | moment("HH:mm") }}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                </div>
                            </CCol>
                        </CRow>
                    </div>
    
    
    
                </div>
    
                <!-- Right Content -->
    
            </div>
    
        </div>
        <Footer />
    </div>
</template>
  
<script>
import Vue from "vue";
import Mainlayout from "../containers/AllHeader.vue";
import Footer from '@/components/Footer.vue'
import _ from "lodash";
export default {
    components: {
        Mainlayout,
        Footer
    },
    data() {
        return {
            orderInfo: [
                { day: '01', course: 'Programming...', date: '12/03/2025', time: '2:30 PM' },
                { day: '02', course: 'Basic Algorithm', date: '12/03/2025', time: '9:00 AM' },
                { day: '03', course: 'Advanced Algo...', date: '12/03/2025', time: '11:15 AM' },
                { day: '04', course: 'Complex Algor...', date: '12/03/2025', time: '3:45 PM' },
            ],
            product: {},
            selectedCourses: [],
            selectedCourseName: "",
            selectedSubjects: [],
    isFullPackageSelected: false,
        }

    },
    computed: {
        parsedDescription() {
            const urlRegex = /(https?:\/\/[^\s]+)/g;
            return this.product.Description.replace(urlRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#1796FD;">${url}</a>`;
            });
        },
        distinctCourseNames() {
            if (!this.product || !this.product.ProductClass) return [];

            const seen = new Set();
            return this.product.ProductClass.filter(course => {
                if (seen.has(course.CourseName)) return false;
                seen.add(course.CourseName);
                return true;
            });
        },
      filteredCourseSessions() {
        if (!this.product || !Array.isArray(this.product.ProductClass)) {
          return [];
        }

        if (!this.selectedCourseName) return this.product.ProductClass;

        return this.product.ProductClass.filter(
          course => course.CourseName === this.selectedCourseName
        );
      },

      // Add this to generate unique subject names for the dropdown
      distinctCourseNames() {
        if (!this.product || !Array.isArray(this.product.ProductClass)) {
          return [];
        }

        const uniqueNames = [
          ...new Set(this.product.ProductClass.map(c => c.CourseName)),
        ];
        return uniqueNames.map(name => ({ CourseName: name }));
      }
    },
    async mounted() {
        const productId = this.$route.params.id;

        if (productId) {
            // 🔁 Load directly from URL param
            await this.GetListProductById(productId);
        } else {
            // 🧪 Fallback: load from localStorage if accessed normally
            const stored = JSON.parse(localStorage.getItem("selectedCourses")) || [];
            this.selectedCourses = stored;
            if (this.selectedCourses.length > 0) {
                await this.GetListProductById(this.selectedCourses[0].ID);
            }
        }

        await this.GetListPackage();
    },
    methods: {
        GoToCart() {
            this.$router.push("Cart");
        },
        GetListProductById(productId) {
            if (!productId) return;
            return this.$API.get(this.$GetListProductById + "?productId=" + productId).then((response) => {
                if (response.status === 200 && response.data) {
                    this.product = response.data;
                }
            });
        },
        GetListPackage() {
            this.$API
                .get(this.$GetListProduct)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.courses = response.data;
                    }
                });
        },
        GetListPackage() {
            this.$API.get(this.$GetListProduct).then((response) => {
                if (response.status == 200 && response.data != null) {
                    this.courses = response.data;
                }
            });
        },
        AddToCartAndGoToCart() {
  const existing = JSON.parse(localStorage.getItem("cartItems")) || [];

  // Build SubjectUIDs for comparison
  const currentUIDs = this.selectedSubjects.map(subject => 
    `${this.product.ID}-${subject.CourseName}-${subject.Date}-${subject.Time}`
  );

  // Filter out already existing SubjectUIDs
  const alreadyInCart = existing.flatMap(item => 
    item.Subjects?.map(s => s.SubjectUID) || []
  );

  const selectedTitle = this.product.Title?.toLowerCase();

// If full package selected, include only the full package subject
const newSubjects = this.selectedSubjects
  .filter(subject => {
    if (this.isFullPackageSelected) {
      return subject.CourseName?.toLowerCase() === selectedTitle;
    }
    return subject.CourseName?.toLowerCase() !== selectedTitle;
  })
  .map(subject => {
    const subjectUID = `${this.product.ID}-${subject.CourseName}-${subject.Date}-${subject.Time}`;

    if (alreadyInCart.includes(subjectUID)) return null;

    return {
      SubjectUID: subjectUID,
      CourseName: subject.CourseName,
      Date: subject.Date,
      Time: subject.Time,
      Price: subject.Price ?? subject.SubjectDetails?.Price ?? 0,
      Discount: subject.Discount,
      Quantity: 1,
      Status: subject.Status,
      ProductClassId: subject.Id,
      SubjectDetails: {
        CourseName: subject.CourseName,
        Date: subject.Date,
        Time: subject.Time,
        Status: subject.Status,
        ProductClassId: subject.Id
      }
    };
  })
  .filter(Boolean); // Remove nulls

  // Only add if there are new subjects
  if (newSubjects.length > 0) {
    existing.push({
      ParentProductId: this.product.ID,
      Title: this.product.Title,
      PicturePath: this.product.PicturePath,
      Price: this.product.Price,
      Discount: this.product.Discount,
      Quantity: 1,
      Status: this.product.Status === true || this.product.Status === "true",
      Subjects: newSubjects,
      TuitionPackageId: this.product.TuitionPackageId,
    });

    localStorage.setItem("cartItems", JSON.stringify(existing));
  }

  // ✅ Finally redirect
  this.$router.push('/shoppingcart');
},
        checkSubjectConflict(course) {
            const selectedTitle = this.product.Title?.toLowerCase();
            const courseName = course.CourseName?.toLowerCase();

            // If user selects full package
            if (courseName === selectedTitle) {
                this.isFullPackageSelected = true;
                this.selectedSubjects = this.product.ProductClass;
                return;
            }

            // If already selected full package, prevent adding loose subject
            if (this.isFullPackageSelected) {
                alert(`You've already selected the package "${this.product.Title}". Please remove it first if you want to choose individual subjects.`);
                this.selectedSubjects = this.selectedSubjects.filter(
                s => s.CourseName.toLowerCase() !== courseName
                );
                return;
            }

            // Prevent duplicate selection of the same loose subject
            const isDuplicate = this.selectedSubjects.some(
                s => s.CourseName.toLowerCase() === courseName
            );

            if (isDuplicate) {
                alert(`The subject "${course.CourseName}" is already selected.`);
                this.selectedSubjects = this.selectedSubjects.filter(
                s => s.CourseName.toLowerCase() !== courseName
                );
            }
        },
        handleCheckboxChange(course) {
  const selectedTitle = this.product.Title?.toLowerCase();
  const courseName = course.CourseName?.toLowerCase();

  // ✅ Handle Full Package checkbox
  if (courseName === selectedTitle) {
    const isSelected = this.selectedSubjects.some(
      s => s.CourseName?.toLowerCase() === selectedTitle
    );

    if (isSelected) {
      // ✅ Full package selected — clear loose subjects and select all
      this.isFullPackageSelected = true;
      this.selectedSubjects = this.product.ProductClass.map(course => ({ ...course }));
    } else {
      // ✅ Full package unchecked — clear everything
      this.isFullPackageSelected = false;
      this.selectedSubjects = [];
    }
    return;
  }

  // ✅ If full package already selected, block loose selection
  if (this.isFullPackageSelected) {
    alert(`You've already selected the full package "${this.product.Title}". Please uncheck it to choose individual subjects.`);
    // Roll back this subject from selected list
    this.selectedSubjects = this.selectedSubjects.filter(
      s => s.CourseName?.toLowerCase() !== courseName
    );
    return;
  }

  // ✅ Prevent duplicate loose subject selection
  const sameSubjectCount = this.selectedSubjects.filter(
    s => s.CourseName?.toLowerCase() === courseName
  ).length;

  if (sameSubjectCount > 1) {
    alert(`The subject "${course.CourseName}" is already selected.`);
    this.selectedSubjects = this.selectedSubjects.filter(
      s => s.CourseName?.toLowerCase() !== courseName
    );
  }
},
isCourseDisabled(course) {
  const selectedTitle = this.product.Title?.toLowerCase();

  // When full package selected, disable loose
  if (this.isFullPackageSelected) {
    return course.CourseName?.toLowerCase() !== selectedTitle;
  }

  // When any loose subjects selected, disable full package
  const hasLooseSubjects = this.selectedSubjects.some(
    s => s.CourseName?.toLowerCase() !== selectedTitle
  );
  if (hasLooseSubjects && course.CourseName?.toLowerCase() === selectedTitle) {
    return true;
  }

  return false;
},
  handleCheckboxClick(course) {
  const selectedTitle = this.product.Title?.toLowerCase();
  if (course.CourseName?.toLowerCase() === selectedTitle) {
    if (this.isFullPackageSelected) {
      this.isFullPackageSelected = false;
      this.selectedSubjects = [];
    }
  }
}
    }
}
</script>
  
<style scoped>
.bg-dark {
    background-color: #0d1117;
}
</style>
